import { VueExtension } from '../../utils/extensions/vue';
import DialogFunc from './functioncall.jsx'
import Dialog from './dialog.jsx';
import './dialog.scss';

VueExtension.WithInstall(Dialog, DialogFunc);

export default Dialog;
